var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input-select',{attrs:{"id":"state","value":_vm.value,"name":"state","label":"State","placeholder":"Select your state...","options":_vm.options},on:{"input":function (val) { return _vm.$emit('input', val); }}})}
var staticRenderFns = []

export { render, staticRenderFns }